import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import '@/plugins/axios'
import * as firebase from "firebase/app"
// Add the Firebase services that you want to use
import "firebase/auth"
import "firebase/firestore"
import "firebase/messaging"

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getToken: state => state.token
}

const firebaseConfig = {
  apiKey: "AIzaSyDj3jn6If8AUQrolBEWuO19z0Jz8v2Gql4",
  authDomain: "intrarebeta.firebaseapp.com",
  databaseURL: "https://intrarebeta.firebaseio.com",
  projectId: "intrarebeta",
  storageBucket: "intrarebeta.appspot.com",
  messagingSenderId: "939888903999",
  appId: "1:939888903999:web:62adc9b1e544474b19b58a",
  measurementId: "G-W5TQF8JP3X"
}

firebase.initializeApp(firebaseConfig)

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/auth/token/login',
        headers: { 'Content-Type': 'application/json' },
        data: user
      };
      axios(config)
        .then(function (res) {
          localStorage.setItem('user-token', res.data.auth_token);
          // Get Instance ID token. Initially this makes a network call, once retrieved
          // subsequent calls to getToken will return from cache.
          if (firebase.messaging.isSupported()) {
            // Verificar que hay un Service Worker antes de obtener el token
            if ('serviceWorker' in navigator) {
              navigator.serviceWorker.ready.then(() => {
                const messaging = firebase.messaging()
                messaging.getToken().then((currentToken) => {
                  if (currentToken) {
                    const config = {
                      method: 'post',
                      url: 'https://empresa-service.intrare.app/devices',
                      headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + res.data.auth_token
                      },
                      data: {
                        registration_id: currentToken,
                        type: 'web'
                      }
                    };
                    axios(config)
                      .then(ok => {
                        console.log('Token Registrado Correctamente en la API')
                      })
                      .catch(error => {
                        console.log('Error al Registrar Token en API')
                      })
                  } else {
                    console.log('No Instance ID token available. Request permission to generate one.');
                  }
                }).catch((err) => {
                  console.warn('Firebase Messaging: No se pudo obtener token de notificaciones', err);
                })
              }).catch((err) => {
                console.warn('Service Worker no listo para Firebase Messaging:', err);
              })
            } else {
              console.log('Service Workers no soportados en este navegador')
            }

          } else {
            console.log('Push Notifications Not Supported')
          }

          commit(AUTH_SUCCESS, res.data.auth_token);
          dispatch(USER_REQUEST);
          resolve(res)
        })
        .catch(function (err) {
          commit(AUTH_ERROR, err);
          localStorage.removeItem('user-token');
          reject(err);
        });
    })
  },

  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    // return new Promise((resolve, reject) => {
    //   const config = {
    //     method: 'post',
    //     url: 'empresa-empresa-service.intrare.app/auth/token/logout',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'authorization': 'Token ' + localStorage.getItem('user-token')
    //     },
    //   };
    //   axios(config)
    //   .then(function () {
    //     commit(AUTH_LOGOUT);
    //     localStorage.removeItem('user-token');
    //     resolve()
    //   })
    //   .catch(function (err) {
    //       commit(AUTH_LOGOUT);
    //       localStorage.removeItem('user-token');
    //       reject(err);
    //   });
    // })

    dispatch('DISCONNECT_WS').catch(() => {});
    commit(AUTH_LOGOUT);
    localStorage.removeItem('user-token');
    localStorage.removeItem('provider-parking-module');
    localStorage.removeItem('guard_shift_started');
    localStorage.removeItem('guard_active_shift');
  }
};


const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.token = resp;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}

